export default __webpack_public_path__ + "df470dbf67dac8f9d77734cd0c73a472.ttf";